import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Select,
  Icon,
  FloatingLabelInput,
  SquareBorderButton,
  Switch
} from '@lyearn-team/frontend-components';
//  import { Style } from 'radium';
import MediaUpload from '../../../../../../components/MediaUpload';
// import EditableCaption from '../../../../components/EditableCaption';
import utils from '../../../../utils/utils';

const cardType = [
  {
    value: 'description',
    label: 'Text'
  },
  {
    value: 'fullimage',
    label: 'Full Card Image'
  },
  {
    value: 'image',
    label: 'Centered Image'
  }
];

const variant = [
  {
    value: 'flashcardGrid',
    label: 'FlashCard grid'
  },
  {
    value: 'flashcardStack',
    label: 'FlashCard stack'
  }
];

const newItem = () => ({
  _id: utils.getNewObjectId(),
  back: {
    type: 'description',
    media: {
      image: {
        key: 'assets/rise/assets/block-defaults/mountains.jpg',
        src: window.constants.imageUrl + 'sample_image_file.jpg',
        type: 'image',
        thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
        originalUrl: 'mountains.jpg'
      }
    },
    description: 'Back of card'
  },
  front: {
    type: 'description',
    media: {
      image: {
        key: 'assets/rise/assets/block-defaults/mountains.jpg',
        src: window.constants.imageUrl + 'sample_image_file.jpg',
        type: 'image',
        thumbnail: window.constants.imageUrl + 'sample_image_file.jpg',
        originalUrl: 'mountains.jpg'
      }
    },
    description: 'Front of card'
  }
});

class FlashCardSettings extends Component {
  static contextTypes = {
    dispatch: PropTypes.func
  };

  state = {
    variantType: this.props.blockItem.variant
  };

  onFrontCardDescriptionChange = (itemId, index) => (e) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: itemId,
      front: {
        ...this.props.blockItem.items[index].front,
        description: e.target.value
      }
    });
  };

  onBackCardDescriptionChange = (itemId, index) => (e) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: itemId,
      back: {
        ...this.props.blockItem.items[index].back,
        description: e.target.value
      }
    });
  };

  onFrontCardTypeChange = (blockItem, index) => ({ value, label }) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: blockItem._id,
      front: {
        ...this.props.blockItem.items[index].front,
        type: value
      }
    });
  };

  onBackCardTypeChange = (blockItem, index) => ({ value, label }) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: blockItem._id,
      back: {
        ...this.props.blockItem.items[index].back,
        type: value
      }
    });
  };

  onBackImageUpload = (blockItem, index) => (s3Url, imagePlaceholder) => {
    // const { size } = blockItem.media.image;

    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem._id,
      back: {
        ...this.props.blockItem.items[index].back,
        media: {
          image: {
            src: s3Url,
            thumbnail: s3Url
          }
        }
      }
    });
  };

  onFrontImageUpload = (blockItem, index) => (s3Url, imagePlaceholder) => {
    // const { size } = blockItem.media.image;
    // console.log(blockItem);
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem._id,
      front: {
        ...this.props.blockItem.items[index].front,
        media: {
          image: {
            src: s3Url,
            thumbnail: s3Url
          }
        }
      }
    });
  };

  onVariantChange = () => ({ value, label }) => {
    const id = this.props.blockItem._id;

    this.setState({
      variantType: value
    });

    this.context.dispatch('UPDATE_ITEM_DATA', {
      id,
      ...this.props.blockItem,
      variant: value
    });
  };

  // componentWillReceiveProps(nextProps) {
  //   console.log(nextProps);
  //   // if (this.props.item._id !== nextProps.item._id) {
  //   //   // this.redactorEditor.destroy();
  //   //   this.redactorEditor.source.setCode(nextProps.item.html);
  //   //   this.initChange = true;
  //   //   // setTimeout(() => this.redactorEditor.insertion.insertRaw(''), 10);
  //   // }
  // }

  onSwitchChange = () => (e) => {
    const id = this.props.blockItem._id;

    const checked = e.target.checked;
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: id,
      settings: {
        ...this.props.blockItem.settings,
        showHint: checked
      }
    });
  };

  addNewItem = index => () => {
    const id = this.props.blockItem._id;
    const items = this.props.blockItem.items;
    items.splice(index, 0, newItem());
    const newItems = items;

    this.context.dispatch('UPDATE_ITEM_DATA', {
      id,
      ...this.props.blockItem,
      items: newItems
    });
  };

  removeItem = index => () => {
    const id = this.props.blockItem._id;
    const items = this.props.blockItem.items;
    items.splice(index, 1);
    const newItems = items;

    this.context.dispatch('UPDATE_ITEM_DATA', {
      id,
      ...this.props.blockItem,
      items: newItems
    });
  };

  renderFrontDescription(item, index) {
    const frontCardDescription = item.front.description;
    return (
      <FloatingLabelInput
        onChange={this.onFrontCardDescriptionChange(item._id, index, this.context.dispatch)}
        value={frontCardDescription}
        placeholder="Add a description"
        style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
        // style={{ color: this.props.theme.color.black1 }}
      />
    );
  }

  renderBackDescription(item, index) {
    const backCardDescription = item.back.description;

    return (
      <FloatingLabelInput
        onChange={this.onBackCardDescriptionChange(item._id, index, this.context.dispatch)}
        value={backCardDescription}
        placeholder="Add a description"
        style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
        // style={{ color: this.props.theme.color.black1 }}
      />
    );
  }

  renderFrontMediaUpload(item, index) {
    const mediaImage = item.front.media.image.src;
    return (
      <MediaUpload
        uniqueId={index + 'front'}
        src={mediaImage}
        uploadDone={this.onFrontImageUpload(item, index)}
      />
    );
  }

  renderBackMediaUpload(item, index) {
    const mediaImage = item.back.media.image.src;
    return (
      <MediaUpload
        uniqueId={index + 'back'}
        src={mediaImage}
        uploadDone={this.onBackImageUpload(item, index)}
      />
    );
  }

  renderFrontCardSelectOption(item, index) {
    this.option = '';
    if (item.front.type === 'description') {
      this.option = [{ label: 'Text', value: item.front.type }];
    }
    if (item.front.type === 'fullimage') {
      this.option = [{ label: 'Full Card Image', value: item.front.type }];
    }
    if (item.front.type === 'image') {
      this.option = [{ label: 'Centered Image', value: item.front.type }];
    }
    return (
      <Select
        onSelect={this.onFrontCardTypeChange(item, index)}
        label="Choose any item"
        options={cardType}
        multiple={false}
        search={false}
        // minWidth="400px"
        selectedOptions={this.option}
        style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
      />
    );
  }

  renderBackCardSelectOption(item, index) {
    this.option = '';
    if (item.back.type === 'description') {
      this.option = [{ label: 'Text', value: item.back.type }];
    }
    if (item.back.type === 'fullimage') {
      this.option = [{ label: 'Full Card Image', value: item.back.type }];
    }
    if (item.back.type === 'image') {
      this.option = [{ label: 'Centered Image', value: item.back.type }];
    }
    return (
      <Select
        onSelect={this.onBackCardTypeChange(item, index)}
        label="Choose any item"
        options={cardType}
        multiple={false}
        search={false}
        // minWidth="400px"
        selectedOptions={this.option}
        style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
      />
    );
  }

  render() {
    const variantType = this.state.variantType;
    const items = this.props.blockItem.items;
    // const totalItemCount = this.props.blockItem.items;
    const numberofItems = this.props.blockItem.items.length;
    this.variantOption = '';
    // console.log(this.props.blockItem.variant);

    if (variantType === 'flashcardGrid') {
      this.variantOption = [{ label: 'FlashCard grid', value: this.props.blockItem.variant }];
    }
    if (variantType === 'flashcardStack') {
      this.variantOption = [{ label: 'FlashCard stack', value: this.props.blockItem.variant }];
    }

    // console.log(numberofItems);
    return (
      <div>
        <div style={{ width: '100%', paddingTop: '30px' }} className="card-setting-text">
          SETTINGS
        </div>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ width: '50%', paddingTop: '15px' }} className="card-layout-text">
            Layout
          </div>

          <div style={{ width: '50%', fontFamily: 'ProximaNova', fontSize: '16px' }}>
            <Select
              onSelect={this.onVariantChange()}
              label="Choose any item"
              options={variant}
              multiple={false}
              search={false}
              // minWidth="400px"
              selectedOptions={this.variantOption}
              inputClassName="selectInputClass"
              style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
            />
          </div>
        </div>

        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ width: '90%', paddingTop: '15px' }} className="card-layout-text">
            Show card flip hint:
          </div>

          <div style={{ width: '10%', paddingTop: '18px', paddingLeft: '20px' }}>
            <Switch
              size="small"
              defaultChecked={this.props.blockItem.settings.showHint}
              onChange={this.onSwitchChange()}
              text=""
            />
          </div>
        </div>

        <div
          style={{ width: '100%', paddingTop: '36px', paddingBottom: '14px' }}
          className="card-setting-text"
        >
          CONTENT
        </div>

        {items.map((item, index) => (
          <div key={index}>
            <div className="block-edit-field-drag-item">
              <div className="block-edit-field-drag-item__container">
                <div className="block-edit-field-drag-item__content">
                  <div style={{ width: '100%' }}>
                    <div
                      className="block-edit-field block-edit-field--no-padding"
                      style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
                    >
                      <div>
                        <div style={{ width: 'auto' }} className="block-edit-label-lyearn">
                          Card
                          {' '}
                          {index + 1}
                          {' '}
Front
                          {' '}
                        </div>

                        {numberofItems > 1 ? (
                          <div
                            style={{ float: 'right', marginTop: '-35px', marginRight: '-12px' }}
                            onClick={this.removeItem(index)}
                            role="button"
                            tabIndex="0"
                          >
                            <div className="block-edit-delete-button__icon">
                              <Icon type="delete" size="15px" />
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      {this.renderFrontCardSelectOption(item, index)}
                    </div>

                    <div className="block-edit-field">
                      <div className="brand--linkColor">
                        {item.front.type === 'description'
                          ? this.renderFrontDescription(item, index)
                          : ''}
                        {item.front.type === 'fullimage'
                          ? this.renderFrontMediaUpload(item, index)
                          : ''}
                        {item.front.type === 'image'
                          ? this.renderFrontMediaUpload(item, index)
                          : ''}
                      </div>
                    </div>

                    <div
                      className="block-edit-field block-edit-field--no-padding"
                      style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
                    >
                      <label className="block-edit-label-lyearn">
                        {' '}
                        Card
                        {index + 1}
                        {' '}
Back
                        {' '}
                      </label>
                      {this.renderBackCardSelectOption(item, index)}
                    </div>

                    <div className="block-edit-field">
                      <div className="brand--linkColor">
                        {item.back.type === 'description'
                          ? this.renderBackDescription(item, index)
                          : ''}
                        {item.back.type === 'fullimage'
                          ? this.renderBackMediaUpload(item, index)
                          : ''}
                        {item.back.type === 'image' ? this.renderBackMediaUpload(item, index) : ''}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="block-edit-field-upload brand--ui">
          <div className="block-edit-field-upload__inner">
            <SquareBorderButton
              text="+ Add Card"
              type="bordered"
              status="normal"
              onClick={this.addNewItem(numberofItems)}
              style={{
                width: '450px',
                height: '44px',
                borderRadius: '2px',
                fontFamily: 'ProximaNova',
                fontSize: '16px'
              }}
            />
            {/* <button className="button button--default button--outline" onClick={this.addNewItem(numberofItems)}>Add</button> */}
          </div>
        </div>
        {/* <button onClick={this.addNewItem(numberofItems)}>Add</button> */}
      </div>
    );
  }
}

export default FlashCardSettings;
